import { ForwardedRef, forwardRef } from "react";
import {
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  ModalBody,
  Button,
  Text,
  ButtonText,
  HStack
} from "@gluestack-ui/themed";

import { Icon } from "@repo/core/components/core/Icon";

import { IModalRefProps } from "../../Modal/types";
import { IModalTemplateType } from "../types";
import { OptionsModalProps } from "./types";
import { Modal } from "../../Modal";
import { OptionStyleMap } from "./constants";

export const OptionsModal = forwardRef(function OptionsModal(
  { title, text, options }: OptionsModalProps,
  ref: ForwardedRef<IModalRefProps>
) {
  return (
    <Modal ref={ref}>
      <ModalHeader>
        <Text size="xl" fontWeight={700} color="$backgroundLight900">
          {title}
        </Text>
        <ModalCloseButton>
          <Icon name="times" size="xs" />
        </ModalCloseButton>
      </ModalHeader>

      <ModalBody>
        <Text size={"sm"}>{text}</Text>
      </ModalBody>
      <ModalFooter borderColor="red">
        <HStack
          width="$full"
          alignItems="center"
          justifyContent="flex-end"
          flexWrap="wrap"
          gap="$3"
        >
          {options?.map((option) => {
            const { label, onPress, type = IModalTemplateType.info } = option;
            const style = OptionStyleMap[type];
            return (
              <Button
                key={label}
                size="sm"
                variant={style.variant}
                action={style.action}
                onPress={onPress}
              >
                <ButtonText>{label}</ButtonText>
              </Button>
            );
          })}
        </HStack>
      </ModalFooter>
    </Modal>
  );
});
